import { Component, EventEmitter, Input, Output } from '@angular/core';

import { StatCardStatusModel } from './typings/stat-card-status';

// A headline figure with its label, an optional caption and a change against a prior period
@Component({
  selector   : 'wor-stat-card',
  styles: [ require('./stat-card.component.scss') ],
  template: require('./stat-card.component.html')
})
export class StatCardComponent {
  @Input() caption      : string              = '';
  @Input() delta        : number              = null;
  @Input() deltaCaption : string              = '';
  @Input() isClickable  : boolean             = false;
  @Input() isInverse    : boolean             = false;
  @Input() isLoading    : boolean             = false;
  @Input() label        : string              = '';
  @Input() status       : StatCardStatusModel = '';
  @Input() value        : string              = '';

  @Output() pressed : EventEmitter<void> = new EventEmitter<void>();

  deltaMagnitude () : string {
    return Math.abs(this.delta || 0).toFixed(1);
  }

  hasDelta () : boolean {
    return this.delta !== null && this.delta !== undefined;
  }

  // a fall reads as good when the figure is one you want down, such as costs
  isNegative () : boolean {
    return this.hasDelta() && ( this.isInverse
      ? this.delta > 0
      : this.delta < 0 );
  }

  isPositive () : boolean {
    return this.hasDelta() && ( this.isInverse
      ? this.delta < 0
      : this.delta > 0 );
  }

  press () : void {
    if ( this.isClickable ) {
      this.pressed.emit();
    }
  }
}
